import AppModal from '@components/modals/AppModal';

function ConfirmDeleteModal({
  isOpen,
  onClose,
  onConfirm,
  submitting,
  title = 'Delete record',
  description = 'You are about to delete this record.',
  preview
}) {
  return (
    <AppModal isOpen={isOpen} onClose={onClose} title={title} size="lg">
      <div className="form-grid">
        <p className="confirm-delete-description">{description}</p>
        {preview || null}
        <div className="table-actions">
          <button className="button-primary" type="button" disabled={submitting} onClick={onConfirm}>
            {submitting ? 'Deleting...' : 'Confirm'}
          </button>
          <button className="button-ghost" type="button" disabled={submitting} onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </AppModal>
  );
}

export default ConfirmDeleteModal;
